import { clearConversationPointers } from "../utils/aiConversationStorage";

const ACCESS_TOKEN_KEY = "ai_bos_access_token";
const REFRESH_TOKEN_KEY = "ai_bos_refresh_token";
const SESSION_MARKER_KEY = "ai_bos_session";
const WORKSPACE_KEY = "ai_bos_workspace_id";
const STORE_KEY = "ai_bos_store_id";

export function getAccessToken() {
  const current = sessionStorage.getItem(ACCESS_TOKEN_KEY);
  if (current) return current;

  const legacy = localStorage.getItem("token");
  if (legacy) {
    sessionStorage.setItem(ACCESS_TOKEN_KEY, legacy);
    localStorage.removeItem("token");
    localStorage.setItem(SESSION_MARKER_KEY, "1");
    return legacy;
  }

  return null;
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function hasSessionMarker() {
  return localStorage.getItem(SESSION_MARKER_KEY) === "1";
}

export function saveTokens(tokens) {
  if (tokens?.access_token) {
    sessionStorage.setItem(ACCESS_TOKEN_KEY, tokens.access_token);
  }

  if (Object.prototype.hasOwnProperty.call(tokens || {}, "refresh_token")) {
    if (tokens.refresh_token) {
      localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refresh_token);
    } else {
      localStorage.removeItem(REFRESH_TOKEN_KEY);
    }
  }

  localStorage.setItem(SESSION_MARKER_KEY, "1");
}

export function clearTokens() {
  clearConversationPointers();
  sessionStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(SESSION_MARKER_KEY);
  localStorage.removeItem("token");
}

export function getWorkspaceId() {
  return localStorage.getItem(WORKSPACE_KEY);
}

export function getStoreId() {
  return localStorage.getItem(STORE_KEY);
}

export function saveTenantContext(workspaceId, storeId) {
  if (workspaceId) localStorage.setItem(WORKSPACE_KEY, workspaceId);
  else localStorage.removeItem(WORKSPACE_KEY);

  if (storeId) localStorage.setItem(STORE_KEY, storeId);
  else localStorage.removeItem(STORE_KEY);
}

export function clearTenantContext() {
  localStorage.removeItem(WORKSPACE_KEY);
  localStorage.removeItem(STORE_KEY);
}
